import {ThemeType} from '../enum/ThemeType'

export const RemovedThemeTypeToThemeTypeMap = new Map<string, ThemeType>([
  ['light', ThemeType.LightModern],
  ['classic-light', ThemeType.LightModern],
  ['classic-dark', ThemeType.FiordNight],
])

export function resolveThemeType(value: unknown): ThemeType {
  if(typeof value !== 'string') {
    return ThemeType.FiordNight
  }
  if(Object.values(ThemeType).includes(value as ThemeType)) {
    return value as ThemeType
  }
  return RemovedThemeTypeToThemeTypeMap.get(value) ?? ThemeType.FiordNight
}
